import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment, a as Host } from './index.js';
import { p as parseHrefProp } from './p-DlCOw5Kl.js';
import { d as defineCustomElement$g } from './p-BbTg3Car.js';
import { d as defineCustomElement$f } from './p-BwWHobpA.js';
import { d as defineCustomElement$e } from './p-sF9rvBC9.js';
import { d as defineCustomElement$d } from './p-CgjIzafk.js';
import { d as defineCustomElement$c } from './p-RWl7wfjL.js';
import { d as defineCustomElement$b } from './p-BDIehgMZ.js';
import { d as defineCustomElement$a } from './p-DMGlYwB7.js';
import { d as defineCustomElement$9 } from './p-DvXL3Xv_.js';
import { d as defineCustomElement$8 } from './p-Bi4IrIfv.js';
import { d as defineCustomElement$7 } from './p-Cullta-8.js';
import { d as defineCustomElement$6 } from './p-TDk124AW.js';
import { d as defineCustomElement$5 } from './p-CW-Ftoto.js';
import { d as defineCustomElement$4 } from './p-BYQE4OHw.js';
import { d as defineCustomElement$3 } from './p-Trmgzgcp.js';
import { d as defineCustomElement$2 } from './p-KbTC_jnR.js';

const mainNavCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:var(--jw-theme-surface-navigation-bg-color);border-right:1px solid var(--jw-theme-surface-divider-color);box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;max-height:100%;padding:.5rem;transition:width .2s ease;width:15rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host wui-scroll-indicator::part(inner){gap:.75rem}nav{display:flex;flex:1;flex-direction:column;max-height:100%}.top-drawer{display:flex;flex:0;flex-direction:column;gap:.75rem;margin-bottom:1rem}.navigation-section{align-items:stretch;display:flex;flex:1;flex-direction:column;max-height:100%;overflow:hidden}.logo-section{align-items:center;align-self:stretch;display:flex;justify-content:space-between;padding:.5rem}.bottom-drawer{align-items:stretch;display:flex;flex:0;flex-direction:column;gap:.5rem}:host([collapsed]){width:3.5rem}:host([collapsed]) .logo-section{flex-direction:column;gap:.75rem;padding:.5rem 0}:host([collapsed]) wui-scroll-indicator::part(inner){gap:.5rem}";

const WuiMainNav$1 = /*@__PURE__*/ proxyCustomElement(class WuiMainNav extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.collapseChanged = createEvent(this, "collapseChanged", 7);
        /**
         * Array of navigation sections with a title and a set of links
         */
        this.navigation = [];
        /**
         * Array of navigation elements to be rendered at the bottom drawer of the main nav. They can be buttons or links.
         */
        this.bottomDrawer = [];
        /**
         * Whether user can collapse/expand the component
         */
        this.collapsible = true;
    }
    toggleCollapse() {
        this.collapsed = !this.collapsed;
        this.collapseChanged.emit(this.collapsed);
    }
    renderLogo() {
        const logoElement = h("wui-logo", { name: "mark", type: "color", size: this.collapsed ? '2xs' : 'sm' });
        if (this.logoLink) {
            return h("a", { ...parseHrefProp(this.logoLink) }, logoElement);
        }
        return logoElement;
    }
    renderNavigationLinks() {
        if (this.navigation.length === 0) {
            return null;
        }
        return (h("section", { class: "navigation-section" }, h("wui-scroll-indicator", { showTagsLabel: !this.collapsed }, this.navigation.map((section, idx) => {
            const { title, links, ...rest } = section;
            return (h(Fragment, null, h("wui-list", { ...rest }, title && !this.collapsed && links.length > 0 && (h("wui-list-item-header", { key: `section-title-${title}-${links.length}`, label: title })), links.map((link, idx) => {
                // omit 'ref' from passthrough props
                const { label, ...rest } = link;
                return (h("wui-list-item", { ...rest, key: `${label}-${idx}`, label: !this.collapsed ? label : undefined, as: ['a', parseHrefProp(link)], variant: "nav" }));
            })), this.collapsed && idx !== this.navigation.length - 1 && h("wui-divider", null)));
        }))));
    }
    renderBottomDrawer() {
        if (this.bottomDrawer.length === 0) {
            return null;
        }
        return (h("section", { class: "bottom-drawer" }, h("wui-divider", null), h("wui-list", null, this.bottomDrawer.map((drawerElement, idx) => {
            const { label, type, ...rest } = drawerElement;
            if (type === 'link') {
                return (h("wui-list-item", { ...rest, key: `${label}-${idx}`, label: !this.collapsed ? label : undefined, as: ['a', parseHrefProp(drawerElement)], variant: "nav" }));
            }
            return (h("wui-list-item", { ...rest, key: `${label}-${idx}`, label: !this.collapsed ? label : undefined, variant: "nav" }));
        }))));
    }
    render() {
        return (h(Host, { key: 'd458720ffac5fc675eac1ba873dc9e468af39fc2' }, h("nav", { key: '657d2b511b9f5490973db548540844eb0780158d' }, h("div", { key: 'f554c4c2484eddeeb3b7fa3f76fe09c4678514ac', class: "top-drawer" }, h("section", { key: '213e7b2756031b7c60bfdb686c87bd105a215ccf', class: "logo-section" }, this.renderLogo(), this.collapsible && (h("wui-close-button", { key: '5302e46cc1774bd466a5914736bf5b5b01e92f29', icon: !this.collapsed ? 'layout-sidebar-left-collapse' : 'layout-sidebar-left-expand', tooltip: !this.collapsed ? 'Collapse' : 'Expand', onClick: () => this.toggleCollapse() }))), !this.collapsed && h("slot", { key: 'c89d930d7278706d17f775ec6deb9284633e22f2', name: "top-content" })), this.renderNavigationLinks(), this.renderBottomDrawer())));
    }
    static get style() { return mainNavCss; }
}, [257, "wui-main-nav", {
        "logoLink": [16, "logo-link"],
        "navigation": [16],
        "bottomDrawer": [16, "bottom-drawer"],
        "collapsed": [1540],
        "collapsible": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-main-nav", "wui-box", "wui-check-input", "wui-close-button", "wui-divider", "wui-form-field", "wui-icon", "wui-list", "wui-list-item", "wui-list-item-header", "wui-logo", "wui-scroll-indicator", "wui-status", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-main-nav":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiMainNav$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-logo":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-scroll-indicator":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiMainNav = WuiMainNav$1;
const defineCustomElement = defineCustomElement$1;

export { WuiMainNav, defineCustomElement };
